import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { TypeObjectMap, TypeLayer } from '../../../../../../../components/Map/providers/enums'
import { NotificationManager } from '../../../../../../../components/Notifications';

import { Modal } from '@gpstrackit/gtc-react-controls';

import {
    setMapRestart,
    addPointers,
    routesEditPanelRouteGetRoute,
    onRefreshRoutes
  } from 'Redux/actions';

import { reset as resetRouteManagerCreateEditModalMain } from '../../../../../../routes/views/templates/components/createEditRouteModalMain/redux/slice';


import { reset as clearCreateEditRoutePoint } from '../../../../../../routes/views/templates/components/createEditRoutePoint/redux/slice'
import { reset as resetEditPanelRoute } from '../../../../../../routes/views/templates/components/editPanelRoute/redux/slice'
import { reset as resetDeleteRoutePoint } from '../../../../../../routes/views/templates/components/deleteRoutePoint/redux/slice'
import { reset as resetDeleteRoute } from '../../../../../../routes/views/templates/components/deleteRoute/redux/slice'

import {
    reset as resetModalCreateEditRoute
} from "../modalCreateEditRoute/redux/slice"

import FSMDeleteRoute from '../../../../../../../modules/routes/views/templates/components/deleteRoute'
import EditPanelRoute from '../../../../../../../modules/routes/views/templates/components/editPanelRoute';
import RoutesDeleteRoutePoints from '../../../../../../../modules/routes/views/templates/components/deleteRoutePoint';

import './style.scss'


const ModalCreateEditRoute = (props) => {

    const { mapRef } = props;

    const { messages, locale } = useIntl();
    const dispatch = useDispatch();

    const routeId = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute?.routeId);
    const open = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute.open);
    const route = useSelector(state => state.routesManagerEditPanelRouteRedux?.route);

    const openCreateEditRoutePoint = useSelector(state => state.routesManagedCreateEditRoutePointRedux.open); 
    const isUpdatedStopOrder = useSelector(state => state.routesManagerEditPanelRouteRedux.isUpdatedStopOrder);
    const openModalDeleteRoute = useSelector(state => state.routesManagerDeleteRedux?.openModal);    
    const loadingSavedRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.loadingSavedRoute);
    const erorrRoutes = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.erorrRoutes);
    const createUpdateRoutePointResponse = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.createUpdateRoutePointResponse);
    const errorCreateUpdateRoutePoint = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.erorrRoutes);

    const paramIsTemplateRoutesModalMain = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isTemplate);
    const paramIsTemplateRealtimeMapsRoutes = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute?.isTemplate);
    const paramIsTemplate = paramIsTemplateRoutesModalMain || paramIsTemplateRealtimeMapsRoutes || false;

    useEffect(()=> {
        return () => {
            dispatch(setMapRestart())
        }
    },[])

    useEffect(() => {
        if(routeId > 0 && route == null){
            dispatch(routesEditPanelRouteGetRoute({id: routeId}))
        }
    },[open, routeId])

    useEffect(()=> {
        let newPointers = []
        //create the points on map when route comes to data
        if(route){
            route?.points?.map((item) => {
                newPointers.push({
                    ...item, 
                    layerName: TypeLayer?.FSMRoute,
                    eventName: item?.typePoint
                })
            });
        }
        dispatch(addPointers(newPointers))
    },[route])

    useEffect(()=> {
        if(isUpdatedStopOrder && routeId > 0){
            dispatch(routesEditPanelRouteGetRoute({id: routeId}))
        }
    },[isUpdatedStopOrder]);

    useEffect(()=> {
        if(loadingSavedRoute || erorrRoutes){
          if(erorrRoutes){
            NotificationManager.error(
              messages[erorrRoutes]? messages[erorrRoutes] : erorrRoutes,
              messages["error"],
              3000,
              null,
              null,
              "warning"
            )
          }else{
            NotificationManager.success(
              messages['fsmRoute_label_add_route_save'],
              messages["success"],
              3000,
              null,
              null,
              "success"
            )
          }
          if(!erorrRoutes){
              //is new template
              dispatch(onRefreshRoutes(true))

              //---------------------------------------
              //Reset the modal to create routes
              dispatch(clearCreateEditRoutePoint())
              dispatch(resetRouteManagerCreateEditModalMain())
              dispatch(resetModalCreateEditRoute())
              dispatch(resetEditPanelRoute())
              dispatch(resetDeleteRoutePoint())
              dispatch(resetDeleteRoute({ openModal: false }))
              //---------------------------------------
          }          
          
          dispatch(resetRouteManagerCreateEditModalMain({ loadingSavedRoute: false, erorrRoutes: null }))
        }
    },[loadingSavedRoute, erorrRoutes])
    
    useEffect(() => {
        if (createUpdateRoutePointResponse) {
          if (errorCreateUpdateRoutePoint) {
            NotificationManager.error(
              messages['routes_error'],
              messages['error'],
              3000,
              null,
              null,
              'warning',
            );
          } else {
            NotificationManager.success(
              messages['routes_create_edit_point_new'],
              messages["success"],
              3000,
              null,
              null,
              "success"
            )  
          }
        }
      }, [createUpdateRoutePointResponse]);

    
    return(
        <div id="divReferenceRoutes" style={{}}>            
            { 
                open &&
                <EditPanelRoute 
                    isRealtimeMaps
                    showEditPanel={open}
                    hiddenButton={true} 
                    mapRef={mapRef}
                    title={paramIsTemplate ? messages['fsmRoute_title'] : messages['fsmRoute_title_schedule'] }
                    closeEditPanel={()=>{
                        dispatch(resetModalCreateEditRoute())
                    }}
                />
            }
            
            <RoutesDeleteRoutePoints />
            { openModalDeleteRoute && <FSMDeleteRoute /> }

        </div>
    )

}

export default ModalCreateEditRoute;